import type {
  CollectionAccessPreviewItem,
  CollectionAccessPreviewRole,
  CollectionAccessPreviewUser
} from './types'

export function buildAccessPreviewItems(
  roles: CollectionAccessPreviewRole[],
  users: CollectionAccessPreviewUser[],
  canManage: boolean
): CollectionAccessPreviewItem[] {
  const items: CollectionAccessPreviewItem[] = []

  for (const role of roles) {
    if (role.canManage !== canManage) continue
    items.push({ kind: 'role', id: role.role, role })
  }

  for (const user of users) {
    if (user.canManage !== canManage) continue
    items.push({ kind: 'user', id: user.id, user })
  }

  return items
}
